import React from 'react';
import { BasicProtectedRoute } from './protected-route';
import { RoleProtectedRoute } from './role-protected-route';
import { UserRoleType } from '../../store/services/userService';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: UserRoleType[]; // Optional - if not provided, only checks authentication
  requireAll?: boolean; // If true, user must have ALL roles. If false (default), user needs ANY of the roles
  fallback?: React.ReactNode; // Custom component to show when unauthorized
  redirectTo?: string; // Custom redirect path (default: /unauthorized)
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  allowedRoles,
  requireAll = false,
  fallback,
  redirectTo,
  children,
}) => {
  // If roles are specified, use RoleProtectedRoute, otherwise use BasicProtectedRoute
  if (allowedRoles) {
    return (
      <RoleProtectedRoute
        allowedRoles={allowedRoles}
        requireAll={requireAll}
        fallback={fallback}
        redirectTo={redirectTo}
      >
        {children}
      </RoleProtectedRoute>
    );
  }
  
  return <BasicProtectedRoute>{children}</BasicProtectedRoute>;
};